import React from "react";
import { Paper, Box, Typography, Tooltip, CircularProgress } from "@mui/material";
import GroupsIcon from "@mui/icons-material/Groups";

export default function UsersRangeCard({
    prevCount,
    focusCount,
    prevLabel,
    focusLabel,
    loading,
    hasPrevData = true,
    hasFocusData = true,
}) {
    const hasAnyData = hasPrevData || hasFocusData;

    return (
        <Paper
            elevation={2}
            sx={{
                p: 3,
                marginBlock: 2,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
            }}
        >
            {loading ? (
                <Box sx={{ width: "100%", textAlign: "center" }}>
                    <CircularProgress size={28} />
                </Box>
            ) : !hasAnyData ? (
                <Box
                    sx={{
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "text.secondary",
                        fontSize: "0.9rem",
                        opacity: 0.8,
                        py: 2,
                    }}
                >
                    No assessment data available for the selected filters.
                </Box>
            ) : (
                <>
                    {/* LEFT: PREVIOUS MONTH */}
                    <Tooltip title={`Users who took assessments in ${prevLabel}`}>
                        <Box>
                            <Typography variant="subtitle2" color="text.secondary">
                                {prevLabel} Users
                            </Typography>

                            <Box sx={{ display: "flex", alignItems: "center", mt: 0.5 }}>
                                <GroupsIcon sx={{ mr: 1, color: "#475569" }} />
                                <Typography variant="h5" sx={{ fontWeight: 700 }}>
                                    {prevCount}
                                </Typography>
                            </Box>
                        </Box>
                    </Tooltip>

                    {/* RIGHT: FOCUS MONTH */}
                    <Tooltip title={`Users who took assessments in ${focusLabel}`}>
                        <Box textAlign="right">
                            <Typography variant="subtitle2" color="text.secondary">
                                {focusLabel} Users
                            </Typography>

                            <Box sx={{ display: "flex", alignItems: "center", mt: 0.5, justifyContent: "right" }}>
                                <GroupsIcon sx={{ mr: 1, color: "#475569" }} />
                                <Typography variant="h5" sx={{ fontWeight: 700 }}>
                                    {focusCount}
                                </Typography>
                            </Box>
                        </Box>
                    </Tooltip>
                </>
            )}
        </Paper>
    );
}
